import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../api';
import toast from 'react-hot-toast';

export const EntriesContext = createContext();

export const EntriesProvider = ({ children }) => {
  const [entries, setEntries] = useState([]);

  const fetchEntries = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/entries`);
      setEntries(res.data);
    } catch (error) {
      toast.error('Failed to load entries');
    }
  };

  const updateEntry = async (id, data) => {
    try {
      await axios.put(`${API_BASE_URL}/api/entries/${id}`, data);
      fetchEntries();
    } catch (error) {
      toast.error('Failed to update entry');
    }
  };

  const deleteEntry = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/api/entries/${id}`);
      fetchEntries();
    } catch (error) {
      toast.error('Failed to delete entry');
    }
  };

  useEffect(() => {
    fetchEntries();
  }, []);

  return (
    <EntriesContext.Provider value={{ entries, setEntries, fetchEntries, updateEntry, deleteEntry }}>
      {children}
    </EntriesContext.Provider>
  );
};
